import { useTranslate } from 'hooks/useTranslate';
import { FC } from 'react';
import { Modal } from 'react-bootstrap';

type Props = {
  planName: string;
  handleCloseModal: () => void;
};

const DeletePlanBeneficiariesHeader: FC<Props> = ({
  planName,
  handleCloseModal,
}: Props) => {
  const { t } = useTranslate();

  return (
    <Modal.Header>
      <h5 className="modal-title">
        {t('DeleteBeneficiaries')}&nbsp;
        <span className="text-muted ff-alt fs-14px text-right">
          ({t(planName)})
        </span>
      </h5>
      <a className="close cursor-pointer" onClick={handleCloseModal}>
        <em className="icon ni ni-cross" />
      </a>
    </Modal.Header>
  );
};

export default DeletePlanBeneficiariesHeader;
